import Spacer from '@components/Spacer';
import { PaymentMethod } from '@components/PaymentMethods';

type Props = {
  creatorSlug: string | null;
  defaultPaymentMethod: Parameters<typeof PaymentMethod>[0]['paymentMethod'] | null;
  isAchPaymentEnabled: boolean;
  isCardPaymentEnabled: boolean;
  unverifiedPaymentMethods: Array<
    & { id: string }
    & Parameters<typeof PaymentMethod>[0]['paymentMethod']
  >
  useDifferentPaymentMethod: boolean;
  userHasCustomerStripeId: boolean;
};

const DefaultPaymentMethod: React.FC<Props> = ({
  creatorSlug,
  defaultPaymentMethod,
  isAchPaymentEnabled,
  isCardPaymentEnabled,
  unverifiedPaymentMethods,
  useDifferentPaymentMethod,
  userHasCustomerStripeId,
}) => {
  if (!userHasCustomerStripeId || !creatorSlug || useDifferentPaymentMethod) {
    return null;
  }

  if (isCardPaymentEnabled) {
    if (defaultPaymentMethod?.card) {
      return (
        <>
          <PaymentMethod
            creator={{ slug: creatorSlug }}
            paymentMethod={defaultPaymentMethod}
            isLoading={false}
            isPrimary
          />
          <Spacer size={12} />
        </>
      );
    }
    return null;
  }

  if (isAchPaymentEnabled) {
    if (unverifiedPaymentMethods.length > 0) {
      return (
        <>
          {unverifiedPaymentMethods.map((paymentMethod) => (
            <PaymentMethod
              creator={{ slug: creatorSlug }}
              key={paymentMethod.id}
              paymentMethod={paymentMethod}
              isLoading={false}
              isPrimary={false}
            />
          ))}
          <Spacer size={12} />
        </>
      );
    }
    if (defaultPaymentMethod?.us_bank_account) {
      return (
        <>
          <PaymentMethod
            creator={{ slug: creatorSlug }}
            paymentMethod={defaultPaymentMethod}
            isLoading={false}
            isPrimary
          />
          <Spacer size={12} />
        </>
      );
    }
  }
  return null;
};

export default DefaultPaymentMethod;